import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "../../assets/jss/material-kit-react/views/components.js";
import TranslatedBooksSection from "./Sections/TranslatedBooksSection";
import AuthoredBooksSection from "./Sections/AuthoredBooksSection";

const useStyles = makeStyles(styles);

export default function LiteraturePage(props) {
  const classes = useStyles();
  const {...rest} = props;
  return (
    <div>
      <Header
        brand="Luminița Voina - Răuț"
        rightLinks={<HeaderLinks/>}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax image={require("assets/img/silhouettes-trees-people-wood-4mp.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Luminița Voina - Răuț</h1>
                <h3 className={classes.subtitle}>
                  Literatura și teatru.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <AuthoredBooksSection/>
          <TranslatedBooksSection/>
        </div>
      </div>
      <Footer/>
    </div>
  );
}
